import { AnimatePresence, motion } from 'framer-motion'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

interface Props {
  ncSign: (data: any) => void
}

export default ({ ncSign }: Props) => {
  useEffect(() => {
    console.log('nc 初始化')
    window.AWSC.use('nc', function (state, module) {
      // 初始化
      window.nc = module.init({
        appkey: 'FFFF0N0N00000000A148',
        scene: 'nc_login',
        renderTo: 'nc',
        // 前端滑动验证通过时会触发该回调参数。您可以在该回调参数中将会话ID（sessionId）、签名串（sig）、请求唯一标识（token）字段记录下来，随业务请求一同发送至您的服务端调用验签。
        success(data) {
          ncSign(data)
        },
        // 滑动验证失败时触发该回调参数。
        fail(failCode) {
          console.error(failCode, '滑动验证失败')
          window.nc.reset()
        },
        // 验证码加载出现异常时触发该回调参数。
        error(errorCode) {
          console.error(errorCode, '验证码加载出现异常')
          window.nc.reset()
        }
      })
    })
  }, [])

  return (
    <Container initial={{ opacity: 0, scale: 0.98 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.98 }}>
      <div id="nc" style={{ width: '300px' }} />
    </Container>
  )
}

const Container = styled(motion.div)`
  .nc_scale {
    border-radius: 17px;
    overflow: hidden;
    box-shadow:
      rgb(183 183 183) 3px 3px 6px 0px inset,
      rgb(255 255 255 / 50%) -3px -3px 6px 1px inset;
  }
  .nc_bg {
    border-radius: 17px 0 0 17px;
  }
  .nc_iconfont {
    height: 34px !important;
    border-radius: 17px;
  }
  .nc-lang-cnt,
  .scale_text {
    text-indent: 0 !important;
  }
`
